import { Routes, Route } from "react-router-dom";
import { AboutMeView } from "../../views/aboutMe/AboutMeView";
import AdminView from "../../views/admin/adminView";
import { ContactView } from "../../views/contact/contactView";
import { HomeView } from "../../views/home/HomeView";
import { MobileView } from "../../views/mobile/mobileView";
import { WebView } from "../../views/web/webView";
import { OtherProjectsView } from "../../views/otherProjects/otherProjectsView";
import { ProductView } from "../../views/productDesign/productView";
import { ShowProject } from "../../views/showProject/showProject";
import {
  aboutMeRoute,
  adminRoute,
  contactRoute,
  homeRoute,
  mobileRoute,
  webRoute,
  otherProjectsRoute,
  productDesignsRoute,
  macrosRoute
} from "../constants/routeConstants";
import { MacrosView } from "../../views/macros/macrosView";

export const AppRoutes = () => {
  return (
    <div className="w-full mx-8 p-4 sm:p-8 bg-gray-200 flex-auto rounded-xl ">
      <Routes>
        <Route path={homeRoute} element={<HomeView />} />
        <Route path={aboutMeRoute} element={<AboutMeView />} />
        <Route
          path={webRoute}
          element={<WebView />}
        />

        <Route path={mobileRoute} element={<MobileView />} />

        <Route
          path={`${mobileRoute}/:key`}
          element={<ShowProject key=":key" />}
        />

        <Route
          path={`${webRoute}/:key`}
          element={<ShowProject key=":key" />}
        />
        <Route path={productDesignsRoute} element={<ProductView />} />
        <Route path={`${productDesignsRoute}/:key`} element={<ShowProject />} />

        <Route path={otherProjectsRoute} element={<OtherProjectsView />} />
        <Route path={`${otherProjectsRoute}/:key`} element={<ShowProject />} />

        <Route path={macrosRoute} element={<MacrosView />} />
        <Route path={`${macrosRoute}/:key`} element={<ShowProject />} />

        <Route path={contactRoute} element={<ContactView />} />
        <Route path={adminRoute} element={<AdminView />} />
      </Routes>
    </div>
  );
};
